import clsx from 'clsx';

import { Icon } from '@atom/mui';
import userSelectors from '@atom/selectors/userSelectors';
import colors from '@atom/styles/colors';

import classes from './permissionsTab.module.css';

interface Row {
  device: string;
  page: string;
  name: string;
  orgAdmin: string;
  manager: string;
  readOnly: string;
  field: string;
}

const PermissionsTable = () => {
  const getPermissionIcon = (level: string) => {
    switch (level) {
      case 'viewOnly': {
        return <Icon color={colors.neutral.gray}>remove_red_eye</Icon>;
      }
      case 'fullAccess': {
        return <Icon color={colors.brand.green}>check</Icon>;
      }
      default: {
        return <Icon color={colors.brand.red}>close</Icon>;
      }
    }
  };

  return (
    <div className={classes.contentContainer}>
      <div className={classes.contentHeader}>
        <div />
        <div className={classes.legendContainer}>
          <div className={classes.legendItem}>
            <p className={classes.legendItemTitle}>Full Functionalities:</p>
            <Icon color={colors.brand.green}>check</Icon>
          </div>
          <div className={classes.legendItem}>
            <p className={classes.legendItemTitle}>View Only:</p>
            <Icon color={colors.neutral.gray}>remove_red_eye</Icon>
          </div>
          <div className={classes.legendItem}>
            <p className={classes.legendItemTitle}>No Access:</p>
            <Icon color={colors.brand.red}>close</Icon>
          </div>
        </div>
      </div>
      <div className={classes.tableHeader}>
        <div className={clsx(classes.column, classes.type)}>Device</div>
        <div className={clsx(classes.column, classes.type)}>Page</div>
        <div className={clsx(classes.column, classes.access)}>Access</div>
        <div className={clsx(classes.column, classes.largeRole)}>
          Organization Admin
        </div>
        <div className={clsx(classes.column, classes.smallRole)}>Manager</div>
        <div className={clsx(classes.column, classes.smallRole)}>Field</div>
        <div className={clsx(classes.column, classes.smallRole)}>Read Only</div>
      </div>
      <div className={classes.tableContainer}>
        {userSelectors.permissionsTable.map((row: Row, index: number) => {
          return (
            <div className={classes.tableRow} key={index}>
              <div className={clsx(classes.column, classes.type, classes.bold)}>
                {row.device || ''}
              </div>
              <div className={clsx(classes.column, classes.type, classes.bold)}>
                {row.page || ''}
              </div>
              <div className={clsx(classes.column, classes.access)}>
                {row.name}
              </div>
              <div className={clsx(classes.column, classes.largeRole)}>
                {getPermissionIcon(row.orgAdmin)}
              </div>
              <div className={clsx(classes.column, classes.smallRole)}>
                {getPermissionIcon(row.manager)}
              </div>
              <div className={clsx(classes.column, classes.smallRole)}>
                {getPermissionIcon(row.field)}
              </div>
              <div className={clsx(classes.column, classes.smallRole)}>
                {getPermissionIcon(row.readOnly)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PermissionsTable;
